module.exports = __webpack_public_path__ + "img/instagram.fc6eb00f.png";